<template>
  <div class="my-info">
    <div class="content">
      <div class="total">
        <div class="total-item">
          <div class="num">{{ totalInfo.recommendCount }}</div>
          <div class="text">累计邀请人数</div>
        </div>
        <div class="total-item">
          <div class="num">{{ totalInfo.buyCount }}</div>
          <div class="text">累计购课人数</div>
        </div>
        <div class="total-item">
          <div class="num">{{ totalInfo.firstRecommendAmount }}</div>
          <div class="text">累计一级奖励金</div>
        </div>
        <div class="total-item">
          <div class="num">
            {{ totalInfo.secondRecommendAmount }}
          </div>
          <div class="text">累计二级奖励金</div>
        </div>
      </div>
      <div class="list-wrapper">
        <div class="tab">
          <div
            class="tab-item"
            :class="{ active: flag === 'recommend' }"
            @click="changeTab('recommend')"
          >
            一级邀请（{{ totalInfo.firstRecommendCount }}）
          </div>
          <div
            class="tab-item"
            :class="{ active: flag === 'buy' }"
            @click="changeTab('buy')"
          >
            一级购课（{{ totalInfo.firstBuyCount }}）
          </div>
        </div>
        <!-- 邀请列表 -->
        <div class="invite-list" v-show="flag === 'recommend'">
          <div class="head">
            <div class="head-item mobile">手机</div>
            <div class="head-item nick">昵称</div>
            <div class="head-item time">兑换时间</div>
            <div class="head-item num">邀请人数</div>
          </div>
          <div class="invite-wrapper">
            <div class="list">
              <div
                class="list-item"
                @click="toDetail(item, 1)"
                v-for="(item, index) in recommendList"
                :key="index"
              >
                <div class="mobile item">{{ item.mobile }}</div>
                <div class="nick item">{{ item.nickName }}</div>
                <div class="time item">{{ item.payDate }}</div>
                <div class="num item">{{ item.secondRecommendCount }}</div>
              </div>
              <div class="item-footer" v-if="recommendList.length">
                已经到底啦～
              </div>
            </div>
          </div>
        </div>
        <!-- 购课列表 -->
        <div class="invite-list" v-show="flag === 'buy'">
          <div class="invite-wrapper">
            <div class="list">
              <div
                class="buy-item"
                @click="toDetail(item, 2)"
                v-for="(item, index) in buyList"
                :key="index"
              >
                <div class="top">
                  <div class="top-item mobile">
                    <div class="top-item-title">手机</div>
                    <div class="top-item-text">{{ item.mobile }}</div>
                  </div>
                  <div class="top-item nick">
                    <div class="top-item-title">昵称</div>
                    <div class="top-item-text">{{ item.nickName }}</div>
                  </div>
                  <div class="top-item time">
                    <div class="top-item-title">购课时间</div>
                    <div class="top-item-text">{{ item.payDate }}</div>
                  </div>
                  <div class="top-item num">
                    <div class="top-item-title">购课人数</div>
                    <div class="top-item-text">
                      {{ item.secondRecommendCount }}
                    </div>
                  </div>
                </div>
                <div class="top mar">
                  <div class="top-item mobile">
                    <div class="top-item-title">购课类型</div>
                    <div class="top-item-text">{{ item.periodTypeName }}</div>
                  </div>
                  <div class="top-item nick">
                    <div class="top-item-title">订单总价</div>
                    <div class="top-item-text">{{ item.price }}</div>
                  </div>
                  <div class="top-item time">
                    <div class="top-item-title">奖励金</div>
                    <div class="top-item-text">{{ item.recommendAmount }}</div>
                  </div>
                  <div class="top-item num">
                    <div class="top-item-title">订单状态</div>
                    <div class="top-item-text">{{ item.stateName }}</div>
                  </div>
                </div>
              </div>
              <div class="item-footer" v-if="buyList.length">已经到底啦～</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" v-if="isBind == 1">
      <div class="btn" @click="getMoney">提取现金</div>
    </div>
  </div>
</template>

<script>
import { myRecommend, buyList, recommendList } from '../../request/api/recommend'
export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.name === 'recommend') {
        vm.flag = 'recommend'
      } else {
        vm.flag = window.localStorage.getItem('flag')
      }
    })
  },
  data () {
    return {
      totalInfo: {},
      recommendList: [],
      buyList: [],
      flag: 'recommend'
    }
  },

  created () {
    this.openid = this.$route.query.openid
    this.isBind = this.$route.query.isBind
    this.getAllInfo(this.openid)
  },
  methods: {
    async getAllInfo (openid) {
      let res = await Promise.all([myRecommend({ openid }), buyList({ openid }), recommendList({ openid })])
      this.totalInfo = res[0].data || {}
      this.buyList = res[1].data.userList || []
      this.recommendList = res[2].data.userList || []
      this.recommendList.forEach(item => {
        item.mobile = item.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
      })
    },
    changeTab (flag) {
      this.flag = flag
      window.localStorage.setItem('flag', flag)
    },
    toDetail (info, type) {
      if (type === 1) {
        this.$router.push({
          name: 'recommendDetail',
          query: {
            userId: info.userId,
            title: info.nickName
          }
        })
      } else {
        this.$router.push({
          name: 'buyDetail',
          query: {
            userId: info.userId,
            title: info.nickName
          }
        })
      }
    },
    getMoney () {
      this.$router.push({
        name: 'withdraw',
        query: {
          openid: this.openid,
          distributorId: this.$route.query.distributorId
        }
      })
    }
  }
}
</script>

<style scoped lang='less'>
.my-info {
  .content {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    background: #7969fc;
    padding: 30px 30px 134px;
    .total {
      display: flex;
      flex-wrap: wrap;
      padding: 20px;
      background: #ffffff;
      border-radius: 16px;
      .total-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 50%;
        padding: 10px 0 30px 0;
        &:nth-of-type(2n-1) {
          border-right: 1px solid #eeeeee;
        }
        &:nth-of-type(-n + 2) {
          border-bottom: 1px solid #eeeeee;
        }
        .num {
          font-size: 48px;
          font-family: SFProDisplay-Medium, SFProDisplay;
          font-weight: 500;
          color: #ff5330;
          line-height: 58px;
        }
        .text {
          margin-top: 8px;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 37px;
        }
      }
    }
    .list-wrapper {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow: hidden;
      margin-top: 30px;
      background: #ffffff;
      border-radius: 16px;
      .tab {
        display: flex;
        .tab-item {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 22px 0;
          font-size: 32px;
          background: #f7f7f7;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 45px;
          &.active {
            background: #fff;
            color: #0293de;
          }
        }
      }
      .invite-list {
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow-y: auto;
        .head {
          display: flex;
          align-items: center;
          padding: 0 30px;
          .head-item {
            display: flex;
            align-items: center;
            height: 100px;
            text-align: left;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 33px;
            &.mobile {
              width: 212px;
            }
            &.nick {
              width: 161px;
            }
            &.time {
              width: 161px;
            }
            &.num {
              flex: 1;
              text-align: right;
            }
          }
        }
        .invite-wrapper {
          flex: 1;
          overflow-y: scroll;
          .list {
            .list-item {
              display: flex;
              align-items: center;
              padding: 30px 30px;
              border-bottom: 1px solid #eeeeee;
              .item {
                text-align: left;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #222222;
                line-height: 40px;
                &.mobile {
                  width: 212px;
                }
                &.nick {
                  width: 161px;
                }
                &.time {
                  width: 161px;
                }
                &.num {
                  flex: 1;
                  text-align: right;
                }
              }
            }
            .buy-item {
              display: flex;
              flex-direction: column;
              padding: 30px 30px;
              border-bottom: 1px solid #eeeeee;
              .top {
                display: flex;
                align-items: center;
                &.mar {
                  margin-top: 32px;
                }
                .top-item {
                  text-align: left;
                  &.mobile {
                    width: 212px;
                  }
                  &.nick {
                    width: 161px;
                  }
                  &.time {
                    width: 161px;
                  }
                  &.num {
                    flex: 1;
                    text-align: right;
                  }
                  .top-item-title {
                    font-size: 24px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    line-height: 33px;
                  }
                  .top-item-text {
                    margin-top: 12px;
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #222222;
                    line-height: 40px;
                  }
                }
              }
            }
            .item-footer {
              height: 100px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 22px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #cccccc;
              line-height: 30px;
            }
          }
        }
      }
    }
  }
  .footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 690px;
      height: 90px;
      background: #0293de;
      border-radius: 45px;
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
</style>